<template>
  <div class="custom-tabbar">
    <div v-for="(item, index) in tabItems"
         :key="item.label" class="tab-item"
         :class="{ active: currentActive === index }"
         @click="onSelect(index)"
    >
      <div class="tab-icon-wrap">
        <van-icon :name="item.icon" class="tab-icon" />
      </div>
      <span class="tab-label">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
/**
 * 底部导航
 * mode = 'full'   四个主入口：首页 / 告警中心 / 数据中心 / 我的
 * mode = 'manage' 两个入口（子账号）：告警中心 / 我的
 */
const TAB_PRESETS = {
  full: [
    { label: '首页', icon: 'wap-home', path: '/homepage' },
    { label: '告警中心', icon: 'bell', path: '/alarm/alarmInfo' },
    { label: '数据中心', icon: 'column', path: '/history/historyInfo' },
    { label: '我的', icon: 'manager', path: '/common/me' }
  ],
  manage: [
    { label: '告警中心', icon: 'bell', path: '/alarm/mulAlarmInfo' },
    { label: '我的', icon: 'manager', path: '/common/me' }
  ]
};

export default {
  name: 'tabular',
  props: {
    active: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: 'full'
    }
  },
  data() {
    return {
      currentActive: this.active
    };
  },
  computed: {
    tabItems() {
      return TAB_PRESETS[this.mode] || TAB_PRESETS.full;
    }
  },
  watch: {
    active(val) {
      this.currentActive = val;
    },
    mode() {
      // 切换入口集合时高亮可能越界，回到第一个
      if (this.currentActive > this.tabItems.length - 1) {
        this.currentActive = 0;
      }
    }
  },
  methods: {
    onSelect(index) {
      if (this.currentActive === index) return;
      this.currentActive = index;
      this.$router.push(this.tabItems[index].path);
    }
  }
}
</script>

<style lang="less" scoped>
/* 高度由内容 + 内边距决定，不再写死 110px；作为 flex 布局的最后一项固定在底部 */
.custom-tabbar {
  flex-shrink: 0;
  display: flex;
  align-items: stretch;
  background: #fff;
  padding: 12px 0 calc(12px + env(safe-area-inset-bottom));
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.08);
  z-index: 100;
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:active {
    transform: scale(0.95);
  }

  &.active {
    .tab-icon-wrap {
      transform: translateY(-4px);

      .tab-icon {
        color: #fff;
      }
    }

    .tab-label {
      color: #1B75F6;
      font-weight: 600;
      transform: translateY(-4px);
    }
  }
}

.tab-icon-wrap {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .tab-icon {
    font-size: 44px;
    color: #9CA3AF;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

.tab-item.active .tab-icon-wrap {
  background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
  box-shadow: 0 6px 18px rgba(27, 117, 246, 0.35);
}

.tab-label {
  font-size: 22px;
  color: #9CA3AF;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
